<template>
<div class="notify-list">
    <div
        v-show="notificationsNotEmpty"
        class="header"
    >
        <span @click="clearAll">
          {{ $t('model.nlu-model.sidebar.notifications.notificationservice.clearAll') }}
        </span>
    </div>
    <div
        v-if="notificationsNotEmpty"
        class="body scroll"
    >
         <div
            v-for="(item, index) in notifications"
            :key="index"
        >
            <notification-item :item="item" />
        </div>
    </div>
    <div
        v-else
        class="placeholder"
    >
        <p>
          {{ $t('model.nlu-model.sidebar.notifications.notificationservice.noNotifications') }}
          <br>
          <span>
            {{ $t('model.nlu-model.sidebar.notifications.notificationservice.youAreUp') }}
          </span>
        </p>
    </div>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import KnowledgeBus from '@/KnowledgeBus'
import notificationItem from './NotificationItem'

export default {
  components: { notificationItem },

  computed: {
    ...mapState('knowledgebase/notifications', ['notifications']),

    notificationsNotEmpty () {
      return !_.isEmpty(this.notifications)
    }
  },

  methods: {
    ...mapActions('knowledgebase/notifications', ['clearNotifications']),

    clearAll () {
      KnowledgeBus.$emit('notifications-popup::close')
      this.clearNotifications()
    }
  }
}
</script>

<style lang="scss" scoped>
    .notify-list {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        overflow-y: auto;

        .header {
            display: flex;
            justify-content: flex-end;
            width: 100%;
            padding: 8px 16px;

            span {
                color: $or-grey-dark;
                font-size: 12px;
                line-height: 28px;
                transition: all .2s ease;

                &:hover {
                    color: darken($or-grey-dark, 10%);
                    cursor: pointer;
                }
            }
        }

        .body {
            display: flex;
            flex-direction: column;
            overflow: auto;
        }

        .placeholder {
            display: flex;
            justify-content: space-around;
            align-items: center;
            height: 100%;

            p {
                text-align: center;
                font-weight: bold;
                font-size: 16px;
                color: $or-black-blue;
                margin-bottom: 32px;

                span {
                    font-size: 12px;
                    font-weight: normal;
                    line-height: 32px;
                }
            }
        }
    }
</style>
